<div class="container" theme [styleObj]='brandStyleTheme'>

  <div class="row">
    <div class="col-12 col-md-4 msg-container">
      <div class="card">

        <div class="card-header">

          <ng-template headerSection></ng-template>

        </div>

        <div class="card-body">


          <div class="accordion" id="myAccordion">
            <div class="accordion-item">
              <h2 class="accordion-header" id="headingOne">
                <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                  NOTIFICATIONS <span class="wp-spacer"></span>Account No: {{extAccountId}}
                </button>
              </h2>
              <div id="collapseOne" class="accordion-collapse collapse show" aria-labelledby="headingOne">
                <div class="accordion-body">

                  <form [formGroup]="notifForm" (ngSubmit)="onSubmitNotification(notifForm.value)">

                    <div class="form-group">

                      <label for="passId" class="col-form-label col-form-label-sm" >Pass Template </label>
                      <select class="form-select form-select-sm mb-3" aria-label=".form-select-lg example"
                        formControlName="passId" (change)="onChangePassTemplate($event)">
                        <!-- <option [ngValue]="">Select Pass Template</option> -->
                        @for (passTemplate of passTemplates; track passTemplate) {
                          <option [ngValue]="passTemplate.value">{{passTemplate.label}}</option>
                        }
                      </select>

                    </div>

                    <div class="form-group">

                      <label for="messageTemplateCode" class="col-form-label col-form-label-sm" >Message Template </label>
                      <select id="#selectMsgTemplate" class="form-select form-select-sm mb-3" aria-label=".form-select-lg example"
                        formControlName="messageTemplateCode" (change)="onChangeMessageTemplate($event)">
                        <!-- <option [ngValue]="">Select Message Template</option> -->
                        @for (messageTemplate of messageTemplates; track messageTemplate) {
                          <option [ngValue]="messageTemplate.value">{{messageTemplate.label}}</option>
                        }
                      </select>

                    </div>


                    @if (isTemplateShown) {
                      <div class="form-group">
                        <label for="templateHeader" class="col-form-label col-form-label-sm" >Template Header</label>
                        <textarea id="templateHeader" [rows]="2" [cols]="36"
                          class="form-control form-control-sm mb-3"
                          pTooltip="The header of the message template" tooltipPosition="top"
                          formControlName="templateHeader" >
                        </textarea>
                      </div>
                    }

                    @if (isTemplateShown) {
                      <div class="form-group">
                        <label for="templateText" class="col-form-label col-form-label-sm" >Message Text </label>
                        <textarea id="templateText" [rows]="2" [cols]="36" class="form-control"
                          class="form-control form-control-sm mb-3"
                          pTooltip="The text of the message template" tooltipPosition="top"
                          formControlName="templateText" >
                        </textarea>
                        <!-- <div class="invalid-feedback">
                        Please provide a message text.
                      </div> -->
                    </div>
                  }

                  <button type="submit" icon="fa fa-check" class="btn btn-secondary btn-sm mb-2"
                    [disabled]="!notifForm.valid">Send Notification</button>

                                        <div class="alert text-center" role="alert" [ngClass]="{
                                            'alert-success': isSuccessMessageOneShown,
                                            'alert-danger': isDangerMessageOneShown
                                          }" [ngClass]="{'alert-dismissible fade show': true}" 
                    >
                    <p>{{messageOneText}}
                      <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                    </p>
                  </div>

                </form>


              </div>
            </div>
          </div>

          <div class="accordion-item">
            <h2 class="accordion-header" id="headingTwo">
              <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                SCENARIOS
              </button>
            </h2>
            <div id="collapseTwo" class="accordion-collapse collapse" aria-labelledby="headingTwo">
              <div class="accordion-body">

                <div class="row">
                  <div class="col-6">
                    <button type="button" icon="fa fa-check" class="btn btn-secondary btn-sm me-2 mb-2" (click)="onPaid()">Paid</button>
                    <button type="button" icon="fa fa-close" class="btn btn-secondary btn-sm me-2 mb-2" (click)="onPastDue()" label="Close">Past Due</button>
                    <button type="button" icon="fa fa-check" class="btn btn-secondary btn-sm me-2 mb-2" (click)="onCycle()" label="Close">Cycle</button>
                    <button type="button" icon="fa fa-close" class="btn btn-secondary btn-sm me-2 mb-2" (click)="onReset()" label="Close">Reset to Current Month</button>
                  </div>
                </div>

                                    <div class="alert text-center" role="alert" [ngClass]="{
                                        'alert-success': isSuccessMessageTwoShown,
                                        'alert-danger': isDangerMessageTwoShown
                                      }" [ngClass]="{'alert-dismissible fade show': true}" 
                  >
                  <p>{{messageTwoText}}
                    <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                  </p>
                </div>

              </div>
            </div>
          </div>

          <div class="accordion-item">
            <h2 class="accordion-header" id="headingThree">
              <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                CURRENT VALUES
              </button>
            </h2>
            <div id="collapseThree" class="accordion-collapse collapse" aria-labelledby="headingThree">
              <div class="accordion-body">

                <main >
                  @for (varValue of varValues; track varValue) {
                    <div>
                      <app-var-value-item [varValue]="varValue" (changeVarValue)="changeVarValueHandler($event)"></app-var-value-item>
                    </div>
                  }
                </main>

                <div class="row">
                  <div class="col-6 offset-md-4 mt-4">
                    <button type="button" icon="fa fa-check" class="btn btn-secondary btn-sm mb-2"
                      (click)="onSubmitDataUpdate($event)" data-bs-toggle="tooltip" data-bs-placement="top"
                      title="Save off updated variable values">Send Data Update
                    </button>
                  </div>
                </div>

                                    <div class="alert text-center" role="alert" [ngClass]="{
                                        'alert-success': isSuccessMessageThreeShown,
                                        'alert-danger': isDangerMessageThreeShown
                                      }" [ngClass]="{'alert-dismissible fade show': true}" 
                  >
                  <p>{{messageThreeText}}
                    <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                  </p>
                </div>

              </div>
            </div>
          </div>

          <div class="accordion-item">
            <h2 class="accordion-header" id="headingFour">
              <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                TASKS
              </button>
            </h2>
            <div id="collapseFour" class="accordion-collapse collapse" aria-labelledby="headingFour">
              <div class="accordion-body">

                <div class="row">
                  <div class="col-6 btn-group-vertical">
                    <button type="button" icon="fa fa-check" class="btn btn-secondary btn-sm mb-2"
                      (click)="onDaqDataBatchRefresher()" data-bs-toggle="tooltip" data-bs-placement="top"
                      title="Refresher all client accounts">DaqDataBatchRefresher
                    </button>
                    <button type="button" icon="fa fa-check" class="btn btn-secondary btn-sm mb-2"
                      (click)="onGenericDaqDatafeedImporter()" data-bs-toggle="tooltip" data-bs-placement="top"
                      title="Import a data file for the client">GenericDaqDatafeedImporter
                    </button>
                    <button type="button" icon="fa fa-check" class="btn btn-secondary btn-sm mb-2"
                      (click)="onGenericOutgoingDatafeedGenerator()" data-bs-toggle="tooltip" data-bs-placement="top"
                      title="Generate outbound files for the client">GenericOutgoingDatafeedGenerator
                    </button>
                    <button type="button" icon="fa fa-check" class="btn btn-secondary btn-sm mb-2"
                      (click)="onAndroidPayScanner()" data-bs-toggle="tooltip" data-bs-placement="top"
                      title="Run the Android Pay Scanner">AndroidPayScanner
                    </button>
                  </div>
                </div>

                                    <div class="alert text-center" role="alert" [ngClass]="{
                                        'alert-success': isSuccessMessageFourShown,
                                        'alert-danger': isDangerMessageFourShown
                                      }" [ngClass]="{'alert-dismissible fade show': true}" 
                  >
                  <p>{{messageFourText}}
                    <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                  </p>
                </div>

              </div>
            </div>
          </div>


        </div>

      </div>

      <div class="card-footer">

        <ng-template footerSection></ng-template>

      </div>

      </div>
    </div>
  </div>

</div>



